import { Sample } from "./sample";

export class LoadBeadchipOFH{
  processFlow: string;
  plateID: string;
  beadchipID1: string;
  beadchipID2: string;
  puid: string;
  liquidHandler: string;
  datetime: Date;
  workFlow: string;
  sampleType: string;
  sender: string;
  samples: Sample[];
  processFlowName: string;
}
export class LoadBeadchipAxiom384{
  processFlow: string;
  beadchipID: string;
  plateID1: string;
  lastUpdatedPlateID1:string;
  plate1ProcessFlowName: string;
  plate1Samples: Sample[];
  plateID2: string;
  lastUpdatedPlateID2:string;
  plate2ProcessFlowName: string;
  plate2Samples: Sample[];
  plateID3: string;
  lastUpdatedPlateID3:string;
  plate3ProcessFlowName: string;
  plate3Samples: Sample[];
  plateID4: string;
  lastUpdatedPlateID4:string;
  plate4ProcessFlowName: string;
  plate4Samples: Sample[];
  puid: string;
  liquidHandler: string;
  datetime: Date;
  workFlow: string;
  sampleType: string;
  sender: string;
  chemicals: any[];
  processFlowName: string;
  priority:number;
  reRun:boolean = false;
}
